import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    lineHeight: 25,
    fontWeight: 700,
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  IconInput: {
    height: 16,
    width: 16,
    backgroundColor: themes.light.white[1],
  },
  iconButton: {
    position: 'absolute',
    right: 10,
    backgroundColor: themes.light.white[1],
    borderWidth: 0,
    cursor: 'pointer',
    fontSize: 18,
  },
  error: {
    color: themes.light.red[3],
    fontSize: 12,
    marginTop: 4,
  },
});
